import PropTypes from 'prop-types';

const { bool, string, shape, object, number, arrayOf, oneOfType, func } =
  PropTypes;

export default shape({
  active: bool,
  market: string,
  config: object,
  service: object,
  state: shape({
    siteName: string,
    siteMode: string,
    priceData: number,
    pageType: string,
    pathKey: string,
    pathChain: arrayOf(oneOfType([string, number])),
    windowWidth: number,
    windowHeight: number,
    placementsMap: object,
  }),
  actions: shape({
    setService: func,
    createAd: func,
  }),
});
